function findChanges(initialArray: Array<any>, formArray: Array<any>, id: keyof Array<any>, field: keyof Array<any> ): { newElements: Array<any>, editedElements: Array<any> } {
  const newElements: Array<any> = [];
  const editedElements: Array<any> = [];

  // Поиск новых элементов
  formArray.forEach((formItem) => {
    const foundItem = initialArray.find((initialItem) => initialItem[id] === formItem[id]);
    if (!foundItem) {
      newElements.push(formItem);
    }
  });

  // Поиск отредактированных элементов
  initialArray.forEach((initialItem) => {
    const foundItem = formArray.find((formItem) => formItem.id === initialItem.id);
    if (foundItem && foundItem[field] !== initialItem[field]) {
      editedElements.push(foundItem);
    }
  });

  return { newElements, editedElements };
}

export default findChanges;